import { Button, Typography } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 32px;
  width: 400px;
`;

export const Title = styled.div`
  color: #333333;
  font-size: 24px;
  font-weight: 500;
  margin: 16px 0;
  text-align: center;
`;

export const Detail = styled.div`
  background-color: #f0f3f6;
  border-radius: 2.5px;
  color: #4f4f4f;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: space-between;
  margin-bottom: 8px;
  padding: 8px 12px;
  width: 100%;
  &.last-child {
    margin-bottom: 24px;
  }
  & > .value {
    margin-left: 10px;
    word-break: break-all;
  }
`;

export const StyledButton = styled(Button)`
  box-shadow: none;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
`;

export const DetailContainer = styled.div`
  margin-bottom: 24px;
  max-height: 352px;
  overflow-y: auto;
  width: 100%;
`;

export const Description = styled(Typography)`
  margin-bottom: 16px;
  text-align: left;
`;

export const DescriptionError = styled(Typography)`
  color: #eb5757;
  margin-bottom: 14px;
  text-align: left;
`;

export const TextareaWrapper = styled.div`
  color: #bdbdbd;
  font-weight: 400;
  margin-bottom: 24px;
  position: relative;
  width: 100%;

  textarea {
    border: 1px solid #bdbdbd;
    border-radius: 2px;
    height: 100px;
    padding: 8px 12px;
    resize: none;
    width: 100%;
  }

  textarea::placeholder {
    color: #bdbdbd;
    font-family: Roboto;
    font-size: 14px;
  }

  .textarea-char-count {
    bottom: 12px;
    font-size: 12px;
    position: absolute;
    right: 8px;
    user-select: none;
  }
`;
